/**
 * Supplemental disposable domains missing from mailchecker / disposable-email-domains.
 * temp-mail.org and similar services rotate new domains frequently — add here when one slips through.
 * @see https://skipsend.com/providers/temp-mail.org/
 */
export const WAPHARMA_EXTRA_DISPOSABLE_DOMAINS = [
  'fixscal.com',
] as const;
